module.exports = __webpack_public_path__ + "img/feed-back.0d3a9fca.svg";